<template lang="pug">
  v-card.mb-3
    v-card-title.title(v-if="options.show_panel_title") {{extra.name}}
    template(v-if="msg")
      v-alert(type="success" :value="true") {{msg}}
    template(v-else)
      v-card-text
        v-layout(row wrap)
          v-flex(xs12 sm6): v-select(label="Anrede" v-model="edit.anrede" :items="anreden" :error-messages="gqlErrorsFor('emailAntragCreate', 'anrede')")
          v-flex(xs12 sm6): v-select(label="Titel" v-model="edit.titel" :items="titel" :error-messages="gqlErrorsFor('emailAntragCreate', 'titel')")
          v-flex(xs12 sm6): v-select(label="Pronouns" v-model="edit.pronouns" :items="pronouns" :error-messages="gqlErrorsFor('emailAntragCreate', 'prounouns')")
          template(v-if="user")
            v-flex(xs12 sm6): v-text-field(label="Vorname" v-model="user.vorname" disabled :error-messages="gqlErrorsFor('emailAntragCreate', 'user')")
            v-flex(xs12 sm6): v-text-field(label="Nachname" v-model="user.nachname" disabled)
          template(v-else)
            v-flex(xs12 sm6): v-text-field(label="Vorname" v-model="edit.vorname" :error-messages="gqlErrorsFor('emailAntragCreate', 'vorname')")
            v-flex(xs12 sm6): v-text-field(label="Nachname" v-model="edit.nachname" :error-messages="gqlErrorsFor('emailAntragCreate', 'nachname')")
          v-flex(xs12): v-autocomplete(label="Organisationseinheit" :items="projekte" v-model="edit.projektId" :error-messages="gqlErrorsFor('emailAntragCreate', 'projekt_id')" item-text="name" item-value="id")
          //- v-flex(xs12 sm6): v-text-field(label="Eintritt" v-model="edit.eintritt" :error-messages="gqlErrorsFor('emailAntragCreate', 'eintritt')")
          //- v-flex(xs12 sm6): v-text-field(label="Austritt" v-model="edit.austritt" :error-messages="gqlErrorsFor('emailAntragCreate', 'austritt')")
          v-flex(xs12): v-textarea(label="Bemerkung" auto-grow v-model="edit.bemerkung" :error-messages="gqlErrorsFor('emailAntragCreate', 'bemerkung')")
      v-card-actions
        v-btn(@click="save" outline color="primary" :loading="loading > 0") Absenden

</template>

<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'
import { user } from '../../router'

export default {
  props: ['extra'],
  mixins: [GraphqlErrorObject],
  data() {
    return {
      user,
      loading: false,
      msg: null,
      edit: {
        vorname: '',
        nachname: '',
        projektId: null,
        bemerkung: '',
        anrede: null,
        titel: null,
        pronouns: null,
        eintritt: null,
        austritt: null,
      },
      anreden: [
        { text: 'Bitte Wählen', value: null },
        { text: 'Herr', value: 'Herr' },
        { text: 'Frau', value: 'Frau' },
        { text: 'Andere', value: 'Andere' },
      ],
      titel: [
        { text: '', value: null },
        { text: 'Dr.', value: 'Dr.' },
        { text: 'Prof.', value: 'Prof.' },
      ],
      pronouns: [
        { text: '', value: null },
        { text: 'He/Him', value: 'He/Him'},
        { text: 'She/Her', value: 'She/Her'},   
        { text: 'They/Them', value: 'They/Them'}, 
        { text: 'other', value: 'other'}
      ]
    }
  },
  apollo: {
    projekte: gql`{ projekte(order: "name") { id name } }`
  },
  computed: {
    options() {
      return this.extra && this.extra.options || {}
    },
    signedIn() {
      return true
    },
  },
  methods: {
    save() {
      this.loading++
      this.gqlClearAllErrors()
      this.$apollo.mutate({
        mutation: gql`mutation (
          $userId: ID
          $vorname: String
          $nachname: String
          $projektId: ID
          $bemerkung: String
          $anrede: String
          $titel: String
          $pronouns: String
          $eintritt: Date
          $austritt: Date
        ) {
          emailAntragCreate(
            userId: $userId
            vorname: $vorname
            nachname: $nachname
            projektId: $projektId
            bemerkung: $bemerkung
            anrede: $anrede
            titel: $titel
            pronouns: $pronouns
            eintritt: $eintritt
            austritt: $austritt
          ) {
            success
          }
        }`,
        variables: {
          ...this.edit,
          userId: user && user.id
        },
      }).then((response) => {
        this.loading--
        this.edit.vorname = ''
        this.edit.nachname = ''
        this.edit.projektId = null
        this.edit.bemerkung = ''
        this.edit.anrede = null
        this.edit.titel = null
        this.edit.pronouns = null
        this.edit.eintritt = null
        this.edit.austritt = null
        if (response.data.emailAntragCreate.success) {
          this.msg = 'Dein E-Mail Antrag wurde abgesendet'
        } else {
          this.msg = 'Ein Fehler is aufgetreten'
        }
      }).catch((error) => {
        this.gqlAddErrors(error)
        this.loading--
      })
    }
  }
}
</script>
